import { FaTrophy, FaStar, FaHeart, FaShareAlt } from "react-icons/fa";
import { communityData, roles, USER_TYPE } from "../../helper/constant";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import PlayerPortfolio from "./PlayerPortfolio";
import Overview from "./Overview";
import Achievement from "./Achievement";
import Button from "../../component/ui/Button";
import ShareModal from "pages/profile/sharePlaymatez";
import ReportUser from "./ReportUser";
import { useDispatch, useSelector } from "react-redux";
import { getOtherUserProfileDetails } from "store/slice/profile";
import moment from "moment";
import FullPageLoader from "component/ui/fullPageLoader";
import { IoChevronBack } from "react-icons/io5";

const PlayerDescription = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("overview");
  const { otherUserProfileData } = useSelector((state) => state.profile);
  const [reportUser, setReportUser] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    if (id) {
      setLoader(true);
      dispatch(getOtherUserProfileDetails(id, setLoader));
    }
  }, [id]);

  console.log("otherUserProfileData", otherUserProfileData);
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-50 py-8 px-4">
      <div className="container mx-auto max-w-6xl">
        {loader && <FullPageLoader />}
        <div
          onClick={() => navigate(-1)}
          className="flex items-center hover:text-highlight cursor-pointer pb-3"
        >
          <IoChevronBack />
          &nbsp; Back
        </div>
        {/* Header Section */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden mb-6">
          {/* Cover Banner */}
          <div className="h-28 bg-gradient-to-r from-[#2BACE2] to-blue-500 relative">
            <div className="absolute top-4 right-4 flex gap-2 items-center">
              <button
                className="px-4 py-2 rounded-full text-white text-sm bg-red-500"
                onClick={() => setReportUser(true)}
              >
                Report User
              </button>

              <button
                className="px-4 py-2 rounded-full text-white text-sm bg-highlight"
                onClick={() => setReportUser(true)}
              >
                Disconnect
              </button>

              {reportUser && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[100]">
                  <ReportUser
                    isOpen={reportUser}
                    data={otherUserProfileData}
                    onClose={() => setReportUser(false)}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="md:px-8 md:pb-8 px-4 pb-4">
            <div className="flex flex-col md:flex-row md:gap-6 gap-2 md:-mt-16 -mt-10">
              {/* Profile Image */}
              <div className="flex justify-center md:justify-start">
                <div className="relative md:w-36 md:h-36 w-24 h-24">
                  {/* Avatar */}
                  <div className="w-full h-full flex items-center justify-center bg-highlight rounded-full border-4 border-white shadow-xl overflow-hidden">
                    {otherUserProfileData?.profileImageUrl ? (
                      <img
                        src={otherUserProfileData?.profileImageUrl}
                        alt={otherUserProfileData?.name}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="text-white text-lg font-bold">
                        {otherUserProfileData?.name &&
                          otherUserProfileData?.name[0]}
                      </div>
                    )}
                  </div>

                  {/* Online status */}
                  {otherUserProfileData?.online && (
                    <span
                      className="absolute bottom-1 right-1 md:bottom-3 md:right-3 
                       w-3 h-3 md:w-4 md:h-4 
                       bg-green-500 rounded-full 
                       border-2 md:border-3 border-white"
                    />
                  )}
                </div>
              </div>

              {/* Player Info */}
              <div className="flex-1 z-10">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                  <div>
                    <h1 className="md:text-3xl text-xl font-semibold md:text-white text-gray-700">
                      {otherUserProfileData?.name}
                    </h1>
                    <p className="md:text-white sm:text-gray-700 flex items-center gap-2">
                      <FaTrophy size={16} />
                      {USER_TYPE[otherUserProfileData?.userType] || "Athlete"}
                    </p>
                  </div>
                </div>

                {/* Stats Cards */}
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                  {otherUserProfileData?.userType == roles?.PLAYER && (
                    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-xl border border-blue-100">
                      <div className="text-2xl font-bold text-[#2BACE2]">
                        {otherUserProfileData?.age
                          ? otherUserProfileData?.age
                          : "N/A"}
                      </div>
                      <div className="text-sm text-gray-600">Age</div>
                    </div>
                  )}
                  {otherUserProfileData?.userType == roles?.PLAYER && (
                    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-xl border border-blue-100">
                      <div className="text-2xl font-bold text-blue-600">
                        {otherUserProfileData?.gender
                          ? otherUserProfileData?.gender
                          : "N/A"}
                      </div>
                      <div className="text-sm text-gray-600">Gender</div>
                    </div>
                  )}
                  {otherUserProfileData?.userType == roles?.VENUE && (
                    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-xl border border-blue-100">
                      <div className="text-2xl font-bold text-blue-600">
                        {otherUserProfileData?.areYouRegisteredVenue
                          ? "Yes"
                          : "No"}
                      </div>
                      <div className="text-sm text-gray-600">
                        Registered Venue
                      </div>
                    </div>
                  )}
                  {otherUserProfileData?.userType == roles?.CLUB && (
                    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-xl border border-blue-100">
                      <div className="text-2xl font-bold text-blue-600">
                        {otherUserProfileData?.areYouRegisteredClub
                          ? "Yes"
                          : "No"}
                      </div>
                      <div className="text-sm text-gray-600">
                        Registered Club
                      </div>
                    </div>
                  )}
                  {otherUserProfileData?.userType != roles?.PLAYER && (
                    <div className="bg-gradient-to-br from-yellow-50 to-orange-50 p-4 rounded-xl border border-yellow-100">
                      <div className="flex items-center gap-1">
                        <span className="text-2xl font-bold text-yellow-600">
                          {otherUserProfileData?.userAverageRating > 0
                            ? otherUserProfileData?.userAverageRating
                            : 0}
                        </span>
                        <FaStar size={20} className="text-yellow-500" />
                      </div>
                      <div className="text-sm text-gray-600">Rating</div>
                    </div>
                  )}
                  {otherUserProfileData?.userType != roles?.PLAYER && (
                    <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-4 rounded-xl border border-green-100">
                      <div className="text-2xl font-bold text-green-600">
                        {otherUserProfileData?.created &&
                          moment(otherUserProfileData?.created).format("YYYY")}
                      </div>
                      <div className="text-sm text-gray-600">Member Since</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ✅ Tabs Section */}
        <div className="bg-white rounded-xl shadow-lg border md:px-6 p-3 md:py-4">
          <div className="flex justify-center md:space-x-20 space-x-7 border-b">
            <button
              onClick={() => setActiveTab("overview")}
              className={`py-2 md:font-medium font-medium md:text-base text-xs ${
                activeTab === "overview"
                  ? "text-[#2BACE2] border-b-2 border-[#2BACE2]"
                  : "text-gray-600"
              }`}
            >
              Overview
            </button>

            <button
              onClick={() => setActiveTab("portfolio")}
              className={`py-2 md:font-medium font-medium md:text-base text-xs ${
                activeTab === "portfolio"
                  ? "text-[#2BACE2] border-b-2 border-[#2BACE2]"
                  : "text-gray-600"
              }`}
            >
              Portfolio
            </button>

            <button
              onClick={() => setActiveTab("achievement")}
              className={`py-2 md:font-medium font-medium md:text-base text-xs ${
                activeTab === "achievement"
                  ? "text-[#2BACE2] border-b-2 border-[#2BACE2]"
                  : "text-gray-600"
              }`}
            >
              Achievement
            </button>
          </div>

          {/* ✅ Tab Content */}
          {otherUserProfileData && (
            <div className="mt-4">
              {activeTab === "overview" && (
                <Overview data={otherUserProfileData} />
              )}
              {activeTab === "portfolio" && (
                <PlayerPortfolio data={otherUserProfileData} />
              )}
              {activeTab === "achievement" && (
                <Achievement data={otherUserProfileData} />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlayerDescription;
